import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";
import { Building, Link } from "lucide-react";
import { Route as patientsOneRoute } from "@/routes/(pharma)/_layout/patients/patient-info/$patientId";
import { useNavigate } from "@tanstack/react-router";

const DetailsPath: React.FC = () => {
  const { patientInfo, patientSales } = patientsOneRoute.useLoaderData();
  const navigate = useNavigate();
  const searchParams = patientsOneRoute.useSearch();
  return (
    <div className="">
      <Breadcrumb>
        <BreadcrumbList className="">
          <BreadcrumbItem>
            <BreadcrumbLink
              onClick={() => {
                navigate({
                  to: "/patients",
                });
              }}
              style={{
                cursor: "pointer",
              }}
            >
              Patients Overview
            </BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage className="font-bold">
              {patientInfo.patient?.name}
            </BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>
      <hr className="my-4" />
    </div>
  );
};

export default DetailsPath;
